import { useTranslation } from 'react-i18next'

import { ScrollableTabs, Text } from '@reveni-io/reveni-ui'

import SaveChangesButtons from '@/common/components/SaveChangesButtons/SaveChangesButtons'
import UnsavedChangesAlert from '@/common/components/UnsavedChangesAlert/UnsavedChangesAlert'
import { userPermissions } from '@/common/constants'
import useUserPermissions from '@/common/hooks/useUserPermissions/useUserPermissions'

import CopyTabContent from './CopyTabContent/CopyTabContent'
import useCopiesConfiguration from './hooks/useCopiesConfiguration'
import useCopiesPageTabs from './hooks/useCopiesPageTabs/useCopiesPageTabs'
import * as Styles from './styles'

const ReturnsPortalCopiesPage = () => {
  const { t } = useTranslation()
  const {
    customCopies,
    savingCustomCopies: saving,
    gettingCustomCopies,
    hasChanges,
    revertChanges,
    onChangeCopy,
    onChangeIsActive,
    isCustomCopyActive,
    saveChanges,
    errors,
    supportedLanguages,
    language,
    returnsPortalUrl,
    merchantInfo,
    address,
  } = useCopiesConfiguration()

  const {
    selectedTab,
    setSelectedTab,
    activePreview,
    setActivePreview,
    previewLanguage,
    setPreviewLanguage,
    handleChangeIsActive,
    tabs,
    copies,
  } = useCopiesPageTabs({ language, errors, onChangeIsActive })

  const { hasPermission } = useUserPermissions()

  return (
    <Styles.Container>
      {hasChanges && <UnsavedChangesAlert hasPermission={hasPermission(userPermissions.editCopies)} />}
      <Text type="bodyMRegular">
        {t('Remplaza el texto por defecto de los mensajes mostrados en el flujo de devoluciones')}:
      </Text>
      <ScrollableTabs value={selectedTab} tabs={tabs} onChange={setSelectedTab} />
      <CopyTabContent
        copies={copies}
        selectedTab={selectedTab}
        activePreview={activePreview}
        onPreviewChange={setActivePreview}
        loading={gettingCustomCopies}
        language={language}
        previewLanguage={previewLanguage}
        errors={errors}
        onChangeCopy={onChangeCopy}
        supportedLanguages={supportedLanguages}
        customCopies={customCopies}
        isCustomCopyActive={isCustomCopyActive}
        onChangeIsActive={handleChangeIsActive}
        onLanguageChange={setPreviewLanguage}
        returnsPortalUrl={returnsPortalUrl}
        merchantInfo={merchantInfo}
        address={address}
      />
      <SaveChangesButtons
        hasChanges={hasPermission(userPermissions.editCopies) && hasChanges}
        onSave={saveChanges}
        onRevertChanges={revertChanges}
        loading={saving}
        disabled={saving}
      />
    </Styles.Container>
  )
}

export default ReturnsPortalCopiesPage
